<script>
import UserAvatar from '@components/user/user-avatar.vue'
import baseMixin from '@mixins/baseMixin'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ProfileMenuCard',
  components: {
    UserAvatar,
  },
  mixins: [baseMixin],
  computed: {
    ...mapGetters({
      user: 'auth/currentUser',
      userFullName: 'auth/currentUserFullName',
      userEmail: 'auth/currentUserEmail',
      isLoggedIn: 'auth/isUserLoggedIn',
      isLoadingAuth: 'auth/isLoadingAuth',
    }),
    darkModeValue() {
      return this.isDarkMode ? 1 : 0
    },
  },
  methods: {
    ...mapActions({
      logout: 'auth/logOut',
      toggleDarkMode: 'toggleDarkMode',
    }),
    async signOut() {
      await this.logout()
    },
  },
}
</script>

<template>
  <!-- Profile Menu Card -->
  <v-card
    v-if="isLoggedIn"
    class="text-center"
    :min-width="!isMobileViewPort ? '350px' : ''"
  >
    <v-list rounded>
      <v-list-item>
        <v-list-item-content class="pb-2">
          <UserAvatar
            v-if="isLoggedIn"
            :name="userFullName"
            size="lg"
            :font-size="16"
          />
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content class="pb-2">
          <v-list-item-title
            id="logged-in-user-name"
            :data-ad-user-name="userFullName"
            class="font-weight-medium text-h6"
            style="font-size: 16px !important"
          >
            {{ userFullName || '' }}
          </v-list-item-title>
          <v-list-item-subtitle
            :title="userEmail"
            class="font-weight-medium mb-2 white-space-normal text-overflow-unset"
          >
            {{ userEmail }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider></v-divider>

    <v-list class="py-0 my-0 text-left">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-subtitle>
            {{ $t('layout.profileMenuThemeSwitchText') }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn-toggle :value="darkModeValue" mandatory dense>
            <v-btn @click="isDarkMode ? toggleDarkMode() : null">
              <v-icon :color="!isDarkMode ? 'warning' : ''">
                mdi-weather-sunny
              </v-icon>
            </v-btn>
            <v-btn @click="!isDarkMode ? toggleDarkMode() : null">
              <v-icon :color="isDarkMode ? 'blue' : ''">
                mdi-weather-night
              </v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-list-item-action>
      </v-list-item>
    </v-list>

    <v-divider></v-divider>

    <v-list>
      <v-list-item>
        <v-list-item-content class="pt-0 pb-0">
          <v-btn
            id="menu-logout-button"
            title="Sign out of your account"
            outlined
            :class="[
              'lc-btn mx-auto rounded-lg font-weight-medium',
              isDarkMode ? 'lc-dark' : '',
            ]"
            @click="signOut"
          >
            Sign Out
          </v-btn>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider></v-divider>

    <v-card-actions class="d-flex justify-center">
      <v-btn
        href="https://anzuk.education/docs/privacy-policy"
        target="_blank"
        text
        small
        class="rounded-lg"
      >
        Privacy
      </v-btn>
      <span aria-hidden="true" class="px-1">•</span>
      <v-btn
        href="https://anzuk.education/docs/terms-and-conditions"
        target="_blank"
        text
        small
        class="rounded-lg"
      >
        Terms
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
